import { HttpInterceptorFn } from '@angular/common/http';
import {
  throwError as observableThrowError,
  Observable,
  catchError,
} from "rxjs";

import { environment } from "@env/environment";
import { AuthService } from "../services/auth/auth.service";
import { inject } from '@angular/core';
export const coreInterceptor: HttpInterceptorFn = (request, next) => {

  let auth = inject(AuthService);
  let cloned: any = {};
  cloned["url"] =
    request.url.startsWith("/api") || request.url.startsWith("/sso")
      ? encodeQueryParams(environment.protocol + "://" + environment.host + request.url)
      : request.url;

  if (auth.isAuthenticated()) {
    let token = String(auth.getJWTLocalStorage()).replace(/['"]+/g, "");
    cloned["headers"] = request.headers.set(
      "Authorization",
      "Bearer " + token
    );
    return next(request.clone(cloned)).pipe(
      catchError((err: any) => {
        if (err.status === 401) {
          auth.logout();
          return observableThrowError({});
        }
        return observableThrowError(err);
      })
    );
  } else {
    return next(request.clone(cloned));
  }
};
function encodeQueryParams(url: string): string {
  const [baseUrl, queryString] = url.split('?');
  if (!queryString) {
    return url;
  }
  const encodedQueryString = queryString
    .split('&')
    .map(param => {
      const [key, value] = param.split('=');
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    })
    .join('&');
  return `${baseUrl}?${encodedQueryString}`;
}
